import React from "react";
import ReactDOM from "react-dom";
import { Retailers } from "./components/RetailerLocator";
import { Provider } from "mobx-react";
import FindDealerStore from "./stores/FindDealerStore";
import PostcodeModal from "../js/components/Postcode/PostcodeModal";
import { BrowserRouter as Router, Route } from "react-router-dom";

// SVG sprite loading - disabled due to webpack-svgstore-plugin incompatibility with webpack 5
// var __sprite__ = {
//   path: "./../images/svg-icons/**/*.svg",
//   name: "./../build/images/svg-icons/icons.svg",
// };
// require("webpack-svgstore-plugin/src/helpers/svgxhr")(__sprite__);

const locationData = window["Location"];
const { postcode, name, state } = locationData || {};

// Only create suburb object if we have valid location data
const suburb = locationData && postcode ? {
  postcode,
  name,
  state,
} : null;

const retailerLocator = document.getElementById("retailerLocator");
if (retailerLocator) {
  const defaultDept = retailerLocator.getAttribute("data-defaultDept");
  const size = Number(retailerLocator.getAttribute("data-size"));
  const findDealerStore = new FindDealerStore(suburb, defaultDept, size);
  const stores = {
    findDealerStore,
  };

  ReactDOM.render(
    <Provider {...stores}>
      <Router>
        <Route render={(props) => <Retailers {...props} />} />
      </Router>
    </Provider>,
    retailerLocator
  );
}

//New Postcode Modal
const pc = document.getElementById("pc");
if (pc) {
  ReactDOM.render(<PostcodeModal content={window["PC_Content"]} />, pc);
}
